import { useNavigate } from 'react-router';
import { useClock, useUI } from '@/state/store';
import { useLoader } from '../store';
import { usePass, passPhase } from './store';
import { usePassNow } from './usePassNow';
import { returnToGlobe } from '@/features/dive/controller';
import { createDiveDeps } from '@/features/dive/deps';
import { useDive } from '@/features/dive/store';
import { TextButton } from '@/components/ui/primitives';

export function PassContextBar() {
  const pass = usePass((s) => s.selected);
  const dataset = useLoader((s) => s.dataset);
  const now = usePassNow();
  const navigate = useNavigate();
  if (!pass) return null;
  const mission = dataset?.missions.find((m) => m.id === pass.missionId);
  const antenna = dataset?.antennas.find((a) => a.id === pass.antennaId);
  return (
    <div
      className="absolute bottom-24 left-3 z-30 max-w-[calc(100%-1.5rem)] rounded-panel border border-hairline bg-raised/95 p-2 text-xs"
      data-testid="twin-pass-context"
    >
      <p>
        {mission?.shortName} → {antenna?.shortName} · {passPhase(pass, now)} · predicted
      </p>
      <p className="mt-1 font-mono text-[10px] text-ink-3">
        {new Date(now).toISOString().replace('T', ' ').slice(0, 19)} UTC
      </p>
      <TextButton
        onClick={async () => {
          if (useDive.getState().phase === 'twin') await returnToGlobe(createDiveDeps(navigate));
          useUI.getState().select({
            missionId: pass.missionId,
            antennaId: pass.antennaId,
            assetId: null,
            subsystemId: null,
          });
          navigate('/loader');
        }}
      >
        Back to pass
      </TextButton>
      <TextButton onClick={() => useClock.getState().setPlaying(!useClock.getState().playing)}>
        Play / pause
      </TextButton>
    </div>
  );
}
